import { useTRPC } from "../../../../trpc/client";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useMerchant } from "../../../../hooks/useMerchant";
import { FiltersType } from "../types/filters.type";

export function useFetchMerchantBills(filters: FiltersType) {
  const { merchant } = useMerchant();
  const trpc = useTRPC();

  const { data, isPending, refetch } = useQuery({
    ...trpc.merchantBills.list.queryOptions({
      rentalsMerchantId: merchant?.id ?? "",
    }),
    enabled: !!merchant?.id,
    refetchInterval: 120_000,
  });

  const allBills = data?.bills ?? [];
  const bills = useMemo(() => {
    if (filters.status === "Pagado")
      return allBills.filter((bill) => bill.paid);
    if (filters.status === "Sin pagar")
      return allBills.filter((bill) => !bill.paid);
    return allBills;
  }, [allBills, filters.status]);

  const totalOutstanding = data?.totalOutstanding ?? 0;

  return {
    bills,
    totalOutstanding,
    isLoading: isPending,
    refetch,
  };
}
